var _defs, _g, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    zoomAndPan: "magnify",
    viewBox: "0 0 1024.5 576",
    height: 768,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fedd839e0e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0.140625 L 1024 0.140625 L 1024 575.859375 L 0 575.859375 Z M 0 0.140625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1a238f4740"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 281.710938 57.710938 L 741.988281 57.710938 L 741.988281 517.988281 L 281.710938 517.988281 Z M 281.710938 57.710938 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fedd839e0e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0.140625 L 1024 0.140625 L 1024 575.859375 L 0 575.859375 Z M 0 0.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0.140625 L 1024 0.140625 L 1024 575.859375 L 0 575.859375 Z M 0 0.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 512.039062 159.042969 C 481.5 159.042969 456.738281 183.800781 456.738281 214.339844 C 456.738281 244.878906 481.5 269.636719 512.039062 269.636719 C 542.578125 269.636719 567.332031 244.878906 567.332031 214.339844 C 567.332031 183.800781 542.578125 159.042969 512.039062 159.042969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1a238f4740)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 512.039062 429.0625 C 512.039062 429.0625 408.261719 287.847656 408.261719 230.53125 C 408.261719 173.214844 454.722656 126.753906 512.039062 126.753906 C 569.347656 126.753906 615.816406 173.214844 615.816406 230.53125 C 615.816406 287.847656 512.039062 429.0625 512.039062 429.0625 Z M 512.039062 57.726562 C 384.84375 57.726562 281.726562 160.84375 281.726562 288.039062 C 281.726562 415.234375 384.84375 518.34375 512.039062 518.34375 C 639.234375 518.34375 742.34375 415.234375 742.34375 288.039062 C 742.34375 160.84375 639.234375 57.726562 512.039062 57.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.2dfcd41e809cbc64c7f522785d748e00.svg";
export { ForwardRef as ReactComponent };